<template>
    <button v-if="ableToEdit" class="btn text-capitalize action ml-4" :class="{completed, approved, accepted}">
      {{ actionLabel }}
    </button>
</template>

<script>
import helpers from '@/Mixins/helpers';

export default {
  mixins: [helpers],

  props: {
    block: Object,
    withCounterparty: Boolean,
  },

  computed: {
    state() {
      return this.$store.state.assetState;
    },

    ableToEdit() {
      let showForStates = [
        'editing',
        'approved',
        'signed',
        'executed',
      ];

      if (showForStates.includes(this.state.state)) {
        return this.userHasRole('contract_lead');
      }

      showForStates = [
        'pending',
      ];

      if (showForStates.includes(this.state.state)) {
        return this.userHasRole('approver');
      }

      return false;
    },

    actionLabel() {
      switch (this.block.state) {
        case 'incomplete':
          return 'Action';

        case 'pending':
          return this.userHasRole('approver') ? 'Review' : 'Done';

        case 'originatorApproved':
          return this.withCounterparty ? 'Review' : 'Approved';

        case 'counterpartyApproved':
          return !this.withCounterparty ? 'Review' : 'Approved';

        case 'accepted':
          return 'Accepted';

        default:
          return 'Review';
      }
    },

    completed() {
      switch (this.block.state) {
        case 'incomplete':
          return false;

        case 'pending':
          return !this.userHasRole('approver');

        case 'originatorApproved':
          return !this.withCounterparty;

        case 'counterpartyApproved':
          return !!this.withCounterparty;

        case 'accepted':
          return true;

        default:
          return false;
      }
    },

    approved() {
      const blockState = this.withCounterparty ? 'counterpartyApproved' : 'originatorApproved';
      return this.block.state === blockState || this.block.state === 'accepted';
    },

    accepted() {
      return this.block.state === 'accepted';
    },

  },
};
</script>
